<div id="flashMessages" class="flash-messages">
    <div id="grayOutDiv" *ngIf='_grayOut && messages.length'></div>
    <div class="alert flash-message alert-{{message.type}} {{message.cssClass}}"
         [ngClass]="{'alert-dismissible':message.showCloseBtn}"
         [style.cursor]="message.closeOnClick?'pointer':'inherit'"
         *ngFor='let message of messages' (click)="alertClicked(message)"
    [@flyInOut]="true">
        <button *ngIf="message.showCloseBtn" type="button" class="close"
                data-dismiss="alert" aria-label="Close" (click)="close(message)">
            <span aria-hidden="true">&times;</span>
        </button>
        <p>{{message.text}}</p>
    </div>
</div>
